import { render, staticRenderFns } from "./campaign-list.vue?vue&type=template&id=5350672f&scoped=true&"
import script from "./campaign-list.vue?vue&type=script&lang=js&"
export * from "./campaign-list.vue?vue&type=script&lang=js&"
import style0 from "./campaign-list.vue?vue&type=style&index=0&id=5350672f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5350672f",
  null
  
)

export default component.exports